import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var MARKETING_OPT_IN = 'marketingOptIn';
export var BILLING_ADDRESS_CAPTURE = 'billing_address_capture';
export var BILLING_ADDRESS_CAPTURE_VARIANT = 'variant';
export var SEARCH_ROOM_PICKER = 'search_room_picker';
export var RC_PRICE_MODIFIER = 'rcPriceModifier';
export var RC_DISTANCE_MODIFIER = 'rcDistanceModifier';
export var RC_HUB_MODIFIER = 'rcHubModifier';
export var ONE_MINUTE = 1;
var COMMON_COOKIE_CONFIGS = {
  mode: 'variant',
  expiryInMinutes: 30
};
export var ANCILLARIES_TABS = _objectSpread(_objectSpread({}, COMMON_COOKIE_CONFIGS), {}, {
  cookieName: 'ancillaries_tabs',
  configName: 'ancillaries'
});
export var GDP_ACCOMPANYING_GUEST_DETAILS = _objectSpread(_objectSpread({}, COMMON_COOKIE_CONFIGS), {}, {
  cookieName: 'guestDetailsAccompanyingGuest',
  configName: 'guestDetailsAccompanyingGuest'
});
export var GDP_DIGI_REG_ADDITIONAL_INFO = _objectSpread(_objectSpread({}, COMMON_COOKIE_CONFIGS), {}, {
  cookieName: 'guestDetailsAdditionalInfo',
  configName: 'guestDetailsAdditionalInfo'
});